import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

export default {
  // Alle Messungen laden
  fetchMeasurements() {
    const url = buildUrl("measurements")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // Eine einzelne Messung laden
  fetchMeasurement(measurementId) {
    const url = buildUrl(`measurement/${measurementId}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // Eine neue Messung erstellen
  addMeasurement(data) {
    const url = buildUrl("measurement")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },

  // Bestehende Messung aktualisieren
  updateMeasurement(measurementId, data) {
    const url = buildUrl(`measurement/${measurementId}`)
    return axios.put(url, data, buildOptions()).then((res) => res.data)
  },

  // Messung löschen
  deleteMeasurement(measurementId) {
    const url = buildUrl(`measurement/${measurementId}`)
    return axios.delete(url, buildOptions()).then((res) => res.data)
  },
}
